import { MainContainer } from '@/components/layout';
import { ChatArea, ChatInput, useChatHandlers, useConversationManager } from '@/features/chat';
import { useChatStore } from '@/stores/chatStore';

export default function ChatPage() {
    const { isStreaming, isMessagesLoading, isEmpty } = useChatStore();

    // Manage conversation state and URL parameters
    const { conversationId, currentConversationId, updateConversationUrl } = useConversationManager();

    // Handle chat submission and streaming
    const { handleChatSubmit, handleResubmitLastUserMessage } = useChatHandlers({
        conversationId,
        currentConversationId,
        onNewConversation: updateConversationUrl,
    });

    return (
        <MainContainer>
            <div className='relative flex h-full flex-col items-center'>
                <ChatArea
                    className='no-scrollbar relative mx-auto h-[93%] w-full max-w-2xl overflow-y-auto pt-4 pb-24'
                    handleResubmit={handleResubmitLastUserMessage}
                    isLoading={isMessagesLoading}
                />
                <div
                    className={
                        'absolute w-full max-w-2xl transition-all duration-400 ease-in-out' +
                        (isEmpty() && !isMessagesLoading ? ' bottom-[47%]' : ' bottom-10')
                    }
                >
                    <ChatInput onSubmit={handleChatSubmit} isSending={isStreaming} className='justify-end' />
                </div>
            </div>
        </MainContainer>
    );
}
